import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "searchpage-layout-buttons" }

import { computed, PropType } from "vue";
import { SearchPageProperties } from "@/types/search-page";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchPageLayoutButtons',
  props: {
  settings: {
    type: Object as PropType<SearchPageProperties>,
    required: true,
  },
  advancedSearchEnabled: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["changeLayout", "toggleAdvancedSearch"],
  setup(__props, { emit: __emit }) {

const props = __props;

const layout = computed<string>(() => props?.settings?.layout || "boxes");

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('changeLayout', 'boxes'))),
      class: _normalizeClass(["icon-th", { xselected: layout.value == 'boxes' }])
    }, null, 2),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('changeLayout', 'table'))),
      class: _normalizeClass(["icon-list", { xselected: layout.value == 'table' }])
    }, null, 2),
    (__props.advancedSearchEnabled)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggleAdvancedSearch', true)))
        }, " Advanced Search "))
      : _createCommentVNode("", true)
  ]))
}
}

})